// extracted by mini-css-extract-plugin
export default {"footer":"ConfirmationModal_footer__QPi2H"};